export default "__VITE_ASSET__e990c254__"